import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldRound extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'round');
  }
}
